import React from 'react';

import Icon from '@components/custom/Icon';

import { getCleanArray } from '@sm/utils/utils';

const ActiveFilters = ({ selectedOptions, removeCategoryFilter}) => {
  return (
    <div className='d-flex active-filters'>
      {Object.entries(selectedOptions).map(([key, value]) => {
        if (!value.length || (value.length === 1 && value[0] === '-1')) return null;
        const title = key.replace(/-.*/, '');
        const values = getCleanArray(value).sort().join(', ');
        return (
          <div key={ value } className='category'>
            <span className='title'>{ title }</span>: { values }
            <Icon
              name='close'
              size={ 14 }
              color='#ffffff'
              style={ { position: 'absolute', right: '5px', top: '5px', cursor: 'pointer', marginRight: 0 } }
              onClick={ () => removeCategoryFilter(key) }
            />
          </div>
        );
      })}
    </div>
  );
};

export default ActiveFilters;